import 'react-international-phone/style.css';
import { defaultCountries, parseCountry, PhoneInput } from 'react-international-phone';
import { Typography } from '@mui/material';

const TOP_LIST_ISO2 = ['fr', 'be', 'es', 'ch', 'de', 'lu', 'gb', 'it', 'nl', 'pt'];

function orderedCountries() {
  const isTopListed = (country) => TOP_LIST_ISO2.includes(parseCountry(country).iso2);
  const topList = defaultCountries.filter(isTopListed);
  const others = defaultCountries.filter((country) => !isTopListed(country));
  return topList.concat(others);
}

export default function PhoneInputField({ value, onChange, error }) {
  return (
    <div>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Téléphone
      </Typography>
      <PhoneInput
        defaultCountry="fr"
        value={value}
        onChange={onChange}
        countries={orderedCountries()}
        style={{ '--react-international-phone-height': '56px' }}
        inputStyle={{ width: '100%', fontSize: '1rem' }}
      />
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </div>
  );
}
